/** Aktivitäten-Liste, FIT-Upload, Herkunft (Quell-Chips, Tooltips, Ersatztitel). */
export default {
  title: 'Aktivitäten',
  kicker: { one: '{count} Aktivität {period}', other: '{count} Aktivitäten {period}' },
  periodAll: 'insgesamt',
  periodYear: 'in {year}',
  search: 'Suchen',
  searchClose: 'Suche schließen',
  searchLabel: 'Suche in Titel und Notiz',
  searchPlaceholder: 'Titel, Notiz …',
  kpis: 'Kennzahlen',
  kpi: { distance: 'Distanz', time: 'Zeit', elevation: 'Höhenmeter', count: 'Anzahl' },
  kpiCount: { one: '{count} Aktivität', other: '{count} Aktivitäten' },
  zugspitzen: '{n} Zugspitzen',
  estimatedSome: 'davon {n} mit geschätzter Last',
  estimatedNone: 'alle mit gemessener Last',
  filter: 'Filter',
  sportGroup: 'Sportart',
  all: 'Alle',
  source: 'Quelle',
  sourceFit: 'Wahoo / FIT',
  sourceStrava: 'Strava-Export',
  year: 'Jahr',
  listFailed: 'Liste nicht geladen: {error}',
  list: 'Liste',
  col: {
    date: 'Datum',
    activity: 'Aktivität',
    distance: 'Distanz',
    time: 'Zeit',
    pace: 'Pace / Tempo',
    hr: 'Ø HF',
    load: 'Last',
    source: 'Quelle',
  },
  loadEstimatedTip: 'geschätzt – keine Herzfrequenz',
  hasMedia: { one: '{count} Foto', other: '{count} Fotos' },
  avgBpm: 'Ø {hr} bpm',
  noHr: 'keine HF',
  footerCount: '{shown} von {total} {period}',
  footerLegend: '„~" = Last geschätzt (keine Herzfrequenz)',
  loading: 'Lädt …',
  more: 'Mehr laden',
  empty: 'Keine Aktivitäten für diesen Filter.',
  upload: {
    created: 'Neu angelegt.',
    known: 'Schon bekannt – nichts geändert.',
    withSource: '{source}-{noun}',
    nounRide: 'Fahrt',
    nounActivity: 'Aktivität',
    withExisting: 'vorhandenen Aktivität',
    primaryFit: ' Die hochgeladene Datei liefert jetzt die Messdaten.',
    primaryOther: ' Messdaten bleiben von {source}.',
    merged: 'Mit {with} zusammengeführt.{primary}',
    failed: 'Upload fehlgeschlagen: {error}',
    busy: 'Lädt …',
    button: 'FIT hochladen',
    buttonLong: 'FIT-Datei hochladen',
    view: 'Ansehen',
  },
  src: {
    strava: 'Strava-Export',
    fit: 'FIT-Upload',
    user: 'dir',
    tipGarmin: 'Garmin Personal API',
    tipStrava: 'aus dem Strava-Export',
    tipUpload: '{main}, manuell hochgeladen',
    replaces: '{main} ersetzt {others}-Fassung ({why})',
    and: ' und ',
    whyRide: 'Rad-Priorität',
    why: 'Quellpriorität',
    titleAndNote: 'Titel und Notiz von {s}',
    titleFrom: 'Titel von {s}',
    noteFrom: 'Notiz von {s}',
    dataFrom: 'Messdaten von {s}',
  },
  fallback: {
    title: '{sport} {part}',
    sport: {
      run: 'Lauf',
      ride: 'Radfahrt',
      swim: 'Schwimmen',
      yoga: 'Yoga',
      strength: 'Krafttraining',
      hike: 'Wanderung',
      walk: 'Spaziergang',
      other: 'Aktivität',
    },
    morning: 'am Morgen',
    noon: 'am Mittag',
    afternoon: 'am Nachmittag',
    evening: 'am Abend',
  },
  longDate: '{wd}, {d}. {month} {y}',
};
